export default "__VITE_ASSET__lna$fAlh__"